import React, { useState } from "react";
import "./LandingPage.css";
import banner from "../../assets/gatewayOfIndia.png";
//import Logo from "../../assets/Logo.svg";
import Logo from "../../assets/Mumbai-check-logo-unit-2.png";
//import Aaye from "../../assets/aaye.svg";
import openMic from "../../assets/openMic.svg";
import Rules from "../components/Rules";
import { useDispatch } from "react-redux";
import * as actions from "../../redux/LandingPage/LandingPageActions";
import { toast } from "react-toastify";
import Tab from "../components/Tab";
import Socials from "../components/Socials";
import FormikForm from "../components/Form";
import Procedure from "../components/Procedure";
import AcceptIcon from "../../assets/accept.png";
import BackIcon from "../../assets/left-arrow.png";

export default function LandingPage() {
  const [currentTab, setCurrentTab] = useState("form");
  const [successScreen, setSuccessScreen] = useState(false);

  const dispatch = useDispatch();

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const savePostInDatabase = (details, setDisabled) => {
    dispatch(actions.savePost(details, setSuccessScreen, setDisabled)).then(
      (response) => {
        if (response) {
          if (response.status) {
            toast.success("आपकी रचना सफलतापूर्वक सबमिट हो गई है");
          } else {
            toast.success("सहेजने में विफल है. कृपया पुन: प्रयास करें।");
          }
        }
      }
    );
  };

  return (
    <div className="landingPage">
      <div className="gradientStrip"></div>
      <div className="tabFixedLogoNavbar">
        <Tab
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
          openInNewTab={openInNewTab}
        />
      </div>
      <div className="landingBody">
        <div className="bannerSection">
          <div className="banner-detail">
            <img src={Logo} alt="banner" className="mumbaiBanner" />
            <div className="banner-detail-mic-aaye">
              <img src={openMic} alt="openMic" className="openMicBanner" />
              {/* <img src={Aaye} alt="Aaye" className="aayeBanner" /> */}
              <p align="center" className="tag-line">
                मनात आलंय तर बोलून टाक
              </p>
            </div>
          </div>
          <div className="banner-poster">
            <img src={banner} alt="banner" className="bannerImage" />
          </div>
        </div>

        <div className="contentContainer">
          <div
            className={`contentSection ${
              currentTab === "form" && successScreen ? "csInMobile" : ""
            }`}
          >
            <div className="formNavbarContainer">
              <div className="tabLogoNavbar">
                <Tab
                  setCurrentTab={setCurrentTab}
                  currentTab={currentTab}
                  openInNewTab={openInNewTab}
                />
              </div>
              <hr />
              {currentTab === "form" && successScreen === false && (
                <div className="formSection">
                  <h1>coming soon / लवकरच येत आहे</h1>
                  {/* <FormikForm savePostInDatabase={savePostInDatabase} /> */}
                </div>
              )}
              {currentTab === "rules" && (
                <div className="rulesSection">
                  <Rules />
                </div>
              )}
              {currentTab === "procedure" && (
                <div className="rulesSection">
                  <Procedure />
                </div>
              )}
              {currentTab === "form" && successScreen && (
                <div>
                  <img
                    style={{ cursor: "pointer" }}
                    title="Back"
                    src={BackIcon}
                    alt="Back"
                    onClick={() => {
                      setCurrentTab("form");
                      setSuccessScreen(false);
                    }}
                  />
                  <div style={{ textAlign: "center", paddingTop: "10px" }}>
                    <img src={AcceptIcon} alt="accept-logo" />
                    <p className="py-2">Thank you for registering with us.</p>
                  </div>
                </div>
              )}
            </div>
            <div className="footer">
              <div className="copyRights">
                © 2023 Mumbai-Tak, All rights reserved.
              </div>
              <Socials openInNewTab={openInNewTab} />
              <div className="copyRights1">
                © 2023 Mumbai-Tak, All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
